import React from 'react'

import { CircularProgress } from '@mui/material'

const LoadingOverlay = () => {
  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10
    }}>
      <CircularProgress color='success' />
    </div>
  )
}

export default LoadingOverlay
